/*
 * Developed for G.J. Gardner Homes by Softeq Development Corporation
 * http://www.softeq.com
 */

import type { GetRowIdParams, GridOptions } from 'ag-grid-community';
import { GridViewport } from '../viewport/grid-viewport.interfaces';

export type RowDataIdGetter<TData = any> = (data: TData) => string | number;

export function getRowIdFromData<TData = any>(
  getId: RowDataIdGetter<TData>,
): (params: GetRowIdParams<TData>) => string {
  return (params: GetRowIdParams<TData>) => String(getId(params.data));
}

export interface GridOptionsExt extends GridOptions {
  viewport?: GridViewport;
  /**
   * Name is used in automation testing in order to distinguish one grid from another.
   */
  name?: string;
  /**
   * This function allows to return id necessary for automation.
   * It is ID that will be injected into data-automation-id attribute
   */
  getRowNodeAutomationId?: RowDataIdGetter;
  /**
   * This options allow to turn off automation.
   */
  noAutomation?: boolean;
}
